import { Injectable } from '@angular/core';

const RINGTONE_URL = 'assets/sounds/ringtone.wav';

@Injectable()
export class RingtoneService {

    private audio: HTMLAudioElement | null = null;

    /** Start playing the ringtone in a loop. Safe to call multiple times. */
    play(): void {
        if (this.audio) return;

        this.audio = new Audio(RINGTONE_URL);
        this.audio.loop = true;
        this.audio.play().catch(err => {
            console.warn('[Ringtone] Autoplay blocked:', err.message);
            this.audio = null;
        });
    }

    /** Stop the ringtone. */
    stop(): void {
        if (!this.audio) return;
        this.audio.pause();
        this.audio.currentTime = 0;
        this.audio = null;
    }

    /** Whether the ringtone is currently playing. */
    get isPlaying(): boolean {
        return this.audio != null && !this.audio.paused;
    }
}
